import { lazy } from 'react';

export const LazyInformationFlagPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--information-flag-page" */ './information-flag-page'
    ),
);
